(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(['exports', 'babel-runtime/helpers/taggedTemplateLiteralLoose', 'react', 'react-emotion', '../styles/colors', '../styles/fonts/fonts', './typography'], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require('babel-runtime/helpers/taggedTemplateLiteralLoose'), require('react'), require('react-emotion'), require('../styles/colors'), require('../styles/fonts/fonts'), require('./typography'));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.taggedTemplateLiteralLoose, global.react, global.reactEmotion, global.colors, global.fonts, global.typography);
    global.Quote = mod.exports;
  }
})(this, function (exports, _taggedTemplateLiteralLoose2, _react, _reactEmotion, _colors, _fonts, _typography) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _taggedTemplateLiteralLoose3 = _interopRequireDefault(_taggedTemplateLiteralLoose2);

  var _react2 = _interopRequireDefault(_react);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  var _templateObject = (0, _taggedTemplateLiteralLoose3.default)(['\n    padding-top: 2rem;\n    padding-bottom: 2rem;\n    text-align: center;\n    margin: 0 auto;\n    max-width: 450px;\n  '], ['\n    padding-top: 2rem;\n    padding-bottom: 2rem;\n    text-align: center;\n    margin: 0 auto;\n    max-width: 450px;\n  ']),
      _templateObject2 = (0, _taggedTemplateLiteralLoose3.default)(['\n    font-size: 13px !important;\n    max-width: 330px;\n    margin: 0 auto;\n    color: #707070 !important; // Slate does not import\n  '], ['\n    font-size: 13px !important;\n    max-width: 330px;\n    margin: 0 auto;\n    color: #707070 !important; // Slate does not import\n  ']),
      _templateObject3 = (0, _taggedTemplateLiteralLoose3.default)(['\n    font-size: 16px;\n    color: ', ';\n    font-weight: bold;\n    font-family: ', ';\n  '], ['\n    font-size: 16px;\n    color: ', ';\n    font-weight: bold;\n    font-family: ', ';\n  ']),
      _templateObject4 = (0, _taggedTemplateLiteralLoose3.default)(['\n    font-family: ', ';\n    text-align: center;\n  '], ['\n    font-family: ', ';\n    text-align: center;\n  ']);

  var Quote = function Quote(_ref) {
    var content = _ref.content,
        author = _ref.author,
        authorTitle = _ref.authorTitle;
    return _react2.default.createElement(
      'div',
      { className: styles.quoteContainer },
      authorTitle ? _react2.default.createElement(
        _react.Fragment,
        null,
        _react2.default.createElement(
          'p',
          null,
          _react2.default.createElement(
            _typography.Paragraph,
            { className: styles.content },
            '"' + content + '"'
          )
        ),
        _react2.default.createElement(
          'p',
          null,
          _react2.default.createElement(
            _typography.Paragraph,
            { bold: true, className: styles.author },
            author
          )
        ),
        _react2.default.createElement(
          _typography.Note,
          { className: styles.authorTitle },
          authorTitle
        )
      ) : _react2.default.createElement(
        'p',
        null,
        _react2.default.createElement(
          _typography.Paragraph,
          { className: styles.content },
          '"' + content + '"',
          ' \u2014 ',
          ' ' + author
        )
      )
    );
  };

  var styles = {
    quoteContainer: (0, _reactEmotion.css)(_templateObject),
    authorTitle: (0, _reactEmotion.css)(_templateObject2),
    author: (0, _reactEmotion.css)(_templateObject3, _colors.prussian, _fonts.ProximaNova),
    content: (0, _reactEmotion.css)(_templateObject4, _fonts.ProximaNova)
  };

  exports.default = Quote;
});


//////////////////
// WEBPACK FOOTER
// ./node_modules/@peachjar/components/build/elements/Quote.js
// module id = 514
// module chunks = 0